import * as React from 'react';
import { styled } from '@glitz/react';
import { translate } from '@avensia/excite';
import { Button } from 'webapp/components/button';
import { createMaxSmallViewportDecorator, createMinMediumViewportDecorator } from 'webapp/viewport';
import { Block, edgeMarginsDecorator, maxContentNormalWidthDecorator } from 'webapp/components/page-layout';
import { BirdsnestIcons } from 'nordicnest/shared/icons';
import { Document, type StyleDecorators } from '@avensia/excite-contentful';
import { Theme, isLightshop, isNordicNest } from 'webapp/theme';
import { useFlyout } from 'webapp/shell/flyout-context';

type PropType = {
  content: (string | Excite.ContentApi.HtmlElementApiModel)[];
};

export function MemberClubNewsletter({ content }: PropType) {
  const { open } = useFlyout('Registration');

  return (
    <>
      <Logos>{isNordicNest && <BirdsnestIcons />}</Logos>
      <Base>
        <Content>
          <Heading>{translate(t => t.registration.memberClubNewsletterTitle)}</Heading>
          <Document elements={content} styleDecorators={styles} />
          <MemberButton onClick={open} as={isLightshop ? Theme.Primary : Theme.Tertiary}>
            {translate(t => t.registration.memberClubNewsletterButtonLabel)}
          </MemberButton>
        </Content>
      </Base>
    </>
  );
}

const Base = styled.div({
  backgroundColor: t => t.memberClubNewsletter?.color,
  color: t => t.memberClubNewsletter?.text,
  padding: { x: t => t.spacing.l, bottom: t => t.spacing.xl, top: t => t.spacing.xxl },
});

const Logos = styled(Block, maxContentNormalWidthDecorator, edgeMarginsDecorator, {
  display: 'flex',
  justifyContent: 'center',
  transform: 'translateY(50%)',
  height: 70,
});

const Content = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  margin: { x: 'auto' },
  width: '100%',
  maxWidth: 800,
  textAlign: 'center',
});

const Heading = styled.h4({
  marginBottom: t => (isNordicNest ? t.sharedSpacing.m : t.sharedSpacing.xl),
  fontSize: t => t.memberClubNewsletter?.fontSize,
  fontFamily: t => t.fontFamily?.secondary,
});

const MemberButton = styled(Button, {
  fontFamily: t => t.fontFamily?.secondary,
});

const styles: StyleDecorators = {
  p: styled(
    createMaxSmallViewportDecorator({
      marginBottom: t => t.spacing.xl,
    }),
    createMinMediumViewportDecorator({
      fontSize: t => t.fontSize.m,
    }),
    {
      fontSize: t => t.fontSize.s,
      fontWeight: 500,
    },
  ),
};
